module.exports = __webpack_public_path__ + "img/10.48a28554.jpg";